import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../../Components/baseUrl";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.css";
import Menu from "../../Components/Menu";

const Returned = () => {
    const navigate = useNavigate();
    let token;
    if (typeof window !== "undefined") {
        token = localStorage.getItem("token");
    }
    useEffect(() => {
        document.title = "پایا | مرجوعی";
        token == null && navigate("/login", { replace: true });
    }, []);
    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    useEffect(() => {
        let status = {
            status: [6, 12],
        };
        let config = {
            url: `${baseUrl}/orders/get-orders-by-status`,
            method: "POST",
            data: status,
        };
        axios(config)
            .then((res) => {
                setLoading(false);
                res && res.data && res.data.data && setList(res.data.data);
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    }, []);
    const [showFilter, setShowFilter] = useState(false);
    const [searchText, setSearchText] = useState("");
    const getOrderHandler = (i) => {
        let status = {
            status: [i],
        };
        let config = {
            url: `${baseUrl}/orders/get-orders-by-status`,
            method: "POST",
            data: status,
        };
        axios(config)
            .then((res) => {
                res && res.data && res.data.data && setList(res.data.data);
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    const searchOrder = (e) => {
        let config = {
            url: `${baseUrl}/orders?search=${searchText}&status=1`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                res && res.data && res.data.data && setList(res.data.data);
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    return (
        <div className="container">
            {showFilter && (
                <div
                    onClick={() => {
                        setShowFilter(false);
                    }}
                    id="bg_gray"
                    className="bg-gray"
                ></div>
            )}
            {showFilter && (
                <div id="filter_modal" className="filter-modal">
                    <div className="filter-modal-head">
                        <svg
                            className="orang-filter"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M2 12C2 6.48 6.44 2 12 2C18.67 2 22 7.56 22 7.56M22 7.56V2.56M22 7.56H17.56"
                                stroke="#FF0000"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                opacity="0.4"
                                d="M21.89 12C21.89 17.52 17.41 22 11.89 22C6.37 22 3 16.44 3 16.44M3 16.44H7.52M3 16.44V21.44"
                                stroke="#FF0000"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </div>
                    <h2>
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M21 7L11 7"
                                stroke="#3BA7E4"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M7 7C7 8.10457 6.10457 9 5 9C3.89543 9 3 8.10457 3 7C3 5.89543 3.89543 5 5 5"
                                stroke="#3BA7E4"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            />
                            <path
                                d="M3 17L13 17"
                                stroke="#3BA7E4"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M17 17C17 18.1046 17.8954 19 19 19C20.1046 19 21 18.1046 21 17C21 15.8954 20.1046 15 19 15"
                                stroke="#3BA7E4"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            />
                        </svg>
                        فیلتر
                    </h2>
                    <button
                        onClick={() => {
                            getOrderHandler(6);
                            setShowFilter(false);
                        }}
                        className="mt-3"
                    >
                        مرجوعی
                    </button>
                    <button
                        onClick={() => {
                            getOrderHandler(12);
                            setShowFilter(false);
                        }}
                        className="mt-3"
                    >
                        برگشتی
                    </button>
                </div>
            )}
            <div className="search-box" id="search_box">
                <div className="pos-rel-search">
                    <input
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        type="text"
                        placeholder="جستجو کنید"
                    />
                    <svg
                        onClick={() => searchOrder()}
                        className="search-svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M18.5831 13.5489C19.204 11.7018 19.1293 9.69155 18.3731 7.89557C17.6169 6.09959 16.2312 4.64137 14.4761 3.79465C12.7209 2.94793 10.7171 2.77094 8.84074 3.29691C6.96438 3.82287 5.3445 5.01562 4.28521 6.65125C3.22592 8.28688 2.80005 10.2529 3.08754 12.1803C3.37504 14.1076 4.35614 15.8638 5.84666 17.1191C7.33718 18.3744 9.23463 19.0424 11.1828 18.9979C13.131 18.9534 14.9959 18.1993 16.4275 16.8772"
                            stroke="#A2A2A2"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M16.5 16.958L21.5 21.958"
                            stroke="#A2A2A2"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
                <div onClick={() => setShowFilter(true)} className="svg-rec">
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className=" c-p"
                    >
                        <path
                            d="M21 7L11 7"
                            stroke="#3BA7E4"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M7 7C7 8.10457 6.10457 9 5 9C3.89543 9 3 8.10457 3 7C3 5.89543 3.89543 5 5 5"
                            stroke="#3BA7E4"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                        />
                        <path
                            d="M3 17L13 17"
                            stroke="#3BA7E4"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M17 17C17 18.1046 17.8954 19 19 19C20.1046 19 21 18.1046 21 17C21 15.8954 20.1046 15 19 15"
                            stroke="#3BA7E4"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                        />
                    </svg>
                </div>
            </div>
            {loading ? (
                <div className="emp-main">
                    <img src="/assets/images/loading.gif" width={50} />
                </div>
            ) : list && list.length !== 0 ? (
                <div className="orders-main">
                    <h1>سفارشات مرجوعی</h1>
                    {list &&
                        list.length !== 0 &&
                        list.map((item) => {
                            if (
                                item.Status == "مرجوعی" ||
                                item.Status == "برگشتی"
                            ) {
                                return (
                                    <a
                                        className="orders-card"
                                        onClick={(e) => {
                                            navigate(
                                                "/panel/factor/" + item.id
                                            );
                                        }}
                                    >
                                        <img
                                            src={
                                                item.company.avatar
                                                    ? item.company.avatar
                                                    : "/assets/images/logo.svg"
                                            }
                                            alt=""
                                        />
                                        <div>
                                            <span className="name">
                                                {item.company.name}
                                            </span>
                                            {/* <span className="fullname">
                                                {item.company.name}{" "}
                                            </span> */}
                                            <span className="numb">
                                                {item.code}
                                            </span>
                                            <div className="dates">
                                                <button>{item.Status}</button>
                                                <span>{item.Created_at}</span>
                                            </div>
                                        </div>
                                    </a>
                                );
                            }
                        })}
                </div>
            ) : (
                <div className="emp-main">
                    <svg
                        width="145"
                        height="145"
                        viewBox="0 0 145 145"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            opacity="0.4"
                            d="M90.0207 12.0833H54.9791C50.8708 12.0833 45.0707 14.5 42.1707 17.4L17.3999 42.1709C14.4999 45.0709 12.0833 50.8709 12.0833 54.9792V90.0208C12.0833 94.1291 14.4999 99.9291 17.3999 102.829L42.1707 127.6C45.0707 130.5 50.8708 132.917 54.9791 132.917H90.0207C94.1291 132.917 99.9291 130.5 102.829 127.6L127.6 102.829C130.5 99.9291 132.917 94.1291 132.917 90.0208V54.9792C132.917 50.8709 130.5 45.0709 127.6 42.1709L102.829 17.4C99.9291 14.5 94.1291 12.0833 90.0207 12.0833Z"
                            fill="#5AD4F0"
                        />
                        <path
                            d="M78.9043 72.5L96.848 54.5562C98.6001 52.8041 98.6001 49.9042 96.848 48.1521C95.0959 46.4 92.1959 46.4 90.4439 48.1521L72.5001 66.0958L54.5563 48.1521C52.8043 46.4 49.9043 46.4 48.1522 48.1521C46.4001 49.9042 46.4001 52.8041 48.1522 54.5562L66.096 72.5L48.1522 90.4437C46.4001 92.1958 46.4001 95.0958 48.1522 96.8479C49.0584 97.7541 50.2064 98.1771 51.3543 98.1771C52.5022 98.1771 53.6501 97.7541 54.5563 96.8479L72.5001 78.9041L90.4439 96.8479C91.3501 97.7541 92.498 98.1771 93.6459 98.1771C94.7939 98.1771 95.9418 97.7541 96.848 96.8479C98.6001 95.0958 98.6001 92.1958 96.848 90.4437L78.9043 72.5Z"
                            fill="#5AD4F0"
                        />
                    </svg>

                    <p className="emp-text">هیچ مرجوعی و برگشتی ثبت نشده است</p>
                </div>
            )}
            <Menu active="cart" />
        </div>
    );
};

export default Returned;
